import React from 'react';

import { css } from '@emotion/css';
import { TenantSettingKey } from '@recurrency/core-api-schema/dist/common/tenantSettings';
import { InventoryDashboardTimeFilters } from '@recurrency/core-api-schema/dist/inventory/getInventoryDashboard';
import { theme } from 'theme';

import { Tabs } from 'components/Tabs';

import { LocalStorageKey, useLocalStorage } from 'utils/localStorage';
import { useHashState } from 'utils/routes';
import { getTenantSetting } from 'utils/tenantSettings';

import { InventoryDashboardHashState, InventoryMissionControlTab } from 'types/hash-state';

import { ExecutiveMetricsPage } from './ExecutiveMetricsPage';
import { InventoryPerformanceTab } from './InventoryPerformanceTab';
import { OverviewTab } from './OverviewTab';

export const InventoryMissionControl = () => {
  const [hashState, updateHashState] = useHashState<InventoryDashboardHashState>();
  const defaultTimeSpan = InventoryDashboardTimeFilters['12M'];

  const [localStorageRecommendedMaxEnabled] = useLocalStorage(
    LocalStorageKey.Demand_Planning_Recommended_Max_Toggle_Enabled,
    getTenantSetting(TenantSettingKey.FeaturePlanningMaxToggleDefault) ?? false,
  );

  if (!hashState || !hashState.filters || !hashState.displayUnit) {
    requestAnimationFrame(async () => {
      updateHashState({ filters: { timeSpan: defaultTimeSpan }, displayUnit: 'value' });
    });
  }
  if (!hashState || hashState.useRecommendedMax === undefined) {
    updateHashState({
      useRecommendedMax: localStorageRecommendedMaxEnabled,
    });
  }

  return (
    <div
      className={css`
        .grid {
          margin-bottom: 18px;
        }
        .ant-select-arrow {
          color: ${theme.colors.neutral[400]};
        }
      `}
    >
      <Tabs
        activeTab={hashState?.inventoryMissionControlTab ?? InventoryMissionControlTab.OVERVIEW}
        onChange={(key) =>
          updateHashState({ ...hashState, inventoryMissionControlTab: key as InventoryMissionControlTab })
        }
        tabs={[
          {
            tabKey: InventoryMissionControlTab.OVERVIEW,
            header: 'Overview',
            content: <OverviewTab />,
          },
          {
            tabKey: InventoryMissionControlTab.DEFAULT,
            header: 'Inventory Performance',
            content: <InventoryPerformanceTab />,
          },
          {
            tabKey: InventoryMissionControlTab.EXECUTIVE,
            header: 'Inventory Operations Health',
            content: <ExecutiveMetricsPage />,
          },
        ]}
      />
    </div>
  );
};
